export { setNonce } from '@stencil/core';
import { bootstrapLazy } from '@stencil/core';
import { patchBrowser } from '@stencil/core/internal/client/patch-browser';
import { globalScripts } from '@stencil/core/internal/app-globals';
patchBrowser().then(options => {
  globalScripts();
  return bootstrapLazy([/*!__STENCIL_LAZY_DATA__*/], options);
});
